import { render } from "./CategorySetting.vue?vue&type=template&id=dcaa82bc"
import script from "./CategorySetting.vue?vue&type=script&lang=js"
export * from "./CategorySetting.vue?vue&type=script&lang=js"

import "./CategorySetting.vue?vue&type=style&index=0&id=dcaa82bc&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__